export default __webpack_public_path__ + "static/media/Acoer-Trademark-Logo-Dark-Mode.9f78bdbb.svg";